import '@/lib/typedef';
import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/warehouses';

export default {
	/**
	 * Fetch All warehouse data
	 *
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getWarehouses(params = { is_deleted: false }, cb, errorCb) {
		// const query = buildQuery(params);
		const url = endpoint;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Store/Create warehouse
	 *
	 * @param {Object} params
	 * @param {Object} params.label Label
	 * @param {string} params.address Address
	 * @param {Object} params.province Province
	 * @param {Object} params.city City
	 * @param {Object} params.subdistric Subdistrict
	 * @param {Boolean} params.default default
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	store(params, cb, errorCb) {
		const url = `${endpoint}`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Delete By Admin
	 *
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	deleteByAdmin(id, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${id}?${query}`;
		client
			.delete(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Delete
	 *
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Update Contact
	 *
	 * @param {string} id Warehouse ID
	 * @param {Object} params
	 * @param {Object} params.label Label
	 * @param {string} params.address Address
	 * @param {Object} params.province Province
	 * @param {Object} params.city City
	 * @param {Object} params.subdistric Subdistrict
	 * @param {Boolean} params.default default
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
